const rootSelector = '.c-modal-sensitive';

function init() {
  const selector = document.querySelector(rootSelector);
  const buttonSelector = document.querySelector(`.c-modal--modal-sensitive`)

  if (!selector) {
    return;
  }

  // Add event listener to the modal
  selector.addEventListener('click', () => {
    buttonSelector.classList.remove('active');
    setCookie('accept-sensitive-content', 'true', 45);
  });
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export default init;
